module.exports = __webpack_public_path__ + "static/Eliza0-a3263a9838c89f6342e804690dcb8e00.png";